<!-- ======================= Page Body ========================== -->
<div class="container page-top-gap">
  <div class="row">
    <div class="col-lg-12">
        <div class="card page-body">
            <div *ngIf="isSuccess==true">
                <!-- ================ Desired Card Selection ================ -->
                <div class="layout-container desired-card">
                    <div class="layout-col width-250">
                        <div class="card-size m-r-20 m-b-20">
                            <img src="{{ cardImgUrl }}" alt="Platinum Credit Card" />
                        </div>
                    </div>
                    <div class="layout-col white-space-wrap font-bold">
                        <p>{{selectedCard}}</p>
                    </div>
                </div>
                <hr />
                <!-- ================ /Desired Card Selection ================ -->
                <!-- ================ Form ================ -->

                <div class="m-t-30">
                    <form action="#">
                        <div class="outer-blue-box">
                            <div class="m-auto flex-single-column p-t-50 card-info-table">
                                <!-- ========= Row ========= -->
                                <div class="row">
                                  <div class="col p-r-20 align-right" i18n="@@CardInfoLabelCreditLimit">
                                    CardInfoLabelCreditLimit
                                  </div>
                                    <div class="col p-l-20 align-left">{{ creditLimit }}</div>
                                </div>
                                <!-- ========= /Row ========= -->
                                <!-- ========= Row ========= -->
                                <div class="row">
                                    <div class="col p-r-20 align-right" i18n="@@CardInfoLabelSelectedCard">CardInfoLabelSelectedCard</div>
                                    <div class="col p-l-20 align-left">
                                        {{ selectedCard }}
                                    </div>
                                </div>
                                <!-- ========= /Row ========= -->
                                <!-- ========= Row ========= -->
                                <!-- ========= /Row ========= -->
                                <!-- ========= Row ========= -->
                                <div class="row">
                                  <div class="col p-r-20 align-right" i18n="@@CardInfoLabelTimeRequiredToRepay">
                                    CardInfoLabelTimeRequiredToRepay
                                  </div>
                                    <div class="col p-l-20 align-left">{{ balancePayOff }}</div>
                                </div>
                                <!-- ========= /Row ========= -->
                                <!-- ========= Row ========= -->
                                <div class="row">
                                  <div class="col p-r-20 align-right" i18n="@@CardInfoLabelAPR">
                                    CardInfoLabelAPR
                                  </div>
                                    <div class="col p-l-20 align-left">{{ aprValue }}</div>
                                </div>
                                <!-- ========= /Row ========= -->
                                <!-- ========= Row ========= -->
                                <div class="row">
                                  <div class="col p-r-20 align-right" i18n="@@CardInfoLabelMonthlyFee">
                                    CardInfoLabelMonthlyFee
                                  </div>
                                    <div class="col p-l-20 align-left">{{ tawarruqFee }}</div>
                                </div>
                                <!-- ========= /Row ========= -->
                                <!-- ========= Row ========= -->
                                <div class="row">
                                    <div class="col p-r-20 align-right" i18n="@@CardInfoLabelAnnualFee">CardInfoLabelAnnualFee</div>
                                    <div class="col p-l-20 align-left">{{ calculatedAnnualFee }}</div>
                                </div>
                                <!-- ========= /Row ========= -->
                                <!-- ========= Row ========= -->
                                <div class="row m-t-30 m-b-30">
                                    <div class="col p-r-20 align-right">
                                        <button *ngIf="!hideApplyOnline" class="btn btn-secondary"
                                                onclick="document.location='https://online.americanexpress.com.sa/applyonline'" i18n="@@ApplyOnline">
                                                ApplyOnline
                                        </button>
                                    </div>
                                    <div class="col p-l-20 align-left">
                                        <button class="btn btn-secondary"
                                                onclick="document.location='https://www.americanexpress.com.sa/comparecards'" i18n="@@CompareCards">
                                                CompareCards
                                        </button>
                                    </div>
                                </div>
                                <!-- ========= /Row ========= -->
                            </div>
                            <hr />
                            <div class="layout-col text-footnote">                             
                              <p i18n="@@CardInfoTNC1">
                                CardInfoTNC1
                              </p>

                              <p i18n="@@CardInfoTNC3">
                                CardInfoTNC3
                              </p>

                              <p>
                                {{CalculationDateInfo}}
                              </p>

                              <p i18n="@@CardInfoTNC4">
                                CardInfoTNC4
                              </p>
                            </div>
                        </div>
                    </form>
                </div>

                <!-- ================ /Form ================ -->
            </div>
            <!-- ================ Error ================ -->
            <div *ngIf="isSuccess==false">
                <div class="section-top m-b-30">
                    <div class="text-feedback">
                        <h3 class="heading-3">{{errorMessage}}</h3>
                    </div>
                </div>
                <hr class="m-t-40">
                <div class="layout-container btn-footer full-page m-auto ieonly-btn-footer">
                    <div class="layout-col">
                        <button class="btn btn-primary btn-next pos-relative" type="button" (click)="backToHome()">
                            <span i18n="@@Ok">Ok</span>
                        </button>
                    </div>
                </div>
            </div>
            <!-- ================ /Error ================ -->
        </div>
    </div>
  </div>
</div>
<!-- ======================= /Page Body ========================== -->
